// extracted by mini-css-extract-plugin
module.exports = {"homeBuyVendorBadge":"HomeBuyVendorBadge_homeBuyVendorBadge__WMAw_"};